module.exports = __webpack_public_path__ + "img/freeze-blue.0ac580a5.svg";